import { getUserMngHistory } from '@/api/userMng';
import { FORMAT_TIME } from '@/types/common';
import { UserMngHistoryItem } from '@/types/userMng';
import { useQuery } from '@tanstack/react-query';
import { Table, Modal, TableColumnType, Space } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';

interface HistoryDialogProps {
  userId: string;
  isOpen: boolean;
  onClose: () => void;
}

const HistoryDialog = ({ userId, isOpen, onClose }: HistoryDialogProps) => {
  const [page, setPage] = useState(1);
  const pageSize = 10;

  const { data: historyData, isLoading } = useQuery({
    queryKey: ['userMngHistory', userId, page],
    queryFn: async () => {
      const resp = await getUserMngHistory({
        userId,
        currentPage: page,
        pageSize,
      });
      return resp.data;
    },
    refetchOnWindowFocus: false,
    enabled: !!userId && isOpen,
  });

  const columns: TableColumnType<UserMngHistoryItem>[] = [
    {
      title: '操作人',
      dataIndex: 'adminName',
    },
    {
      title: '操作类型',
      dataIndex: 'operateUserDesc',
      render: (_, record) => {
        if (record.warnExpireDate) {
          return (
            <Space direction="vertical" size={0}>
              <span>{record.operateUserDesc}</span>
              <span style={{ fontSize: 12, color: '#999' }}>
                将于 {dayjs(record.warnExpireDate).format(FORMAT_TIME)} 到期
              </span>
            </Space>
          );
        }
        return <span>{record.operateUserDesc}</span>;
      },
    },
    {
      title: '操作理由',
      dataIndex: 'operateReason',
    },
    {
      title: '操作时间',
      dataIndex: 'createTime',
      render: (value: string) => {
        return <span>{dayjs(value).format(FORMAT_TIME)}</span>;
      },
    },
  ];

  return (
    <Modal
      width={800}
      open={isOpen}
      onCancel={onClose}
      title="管理记录"
      footer={null}
      destroyOnClose
    >
      <Table
        loading={isLoading}
        size="small"
        rowKey="createTime"
        columns={columns}
        dataSource={historyData?.records || []}
        pagination={{
          total: historyData?.total || 0,
          current: historyData?.currentPage || 1,
          pageSize,
          showSizeChanger: false,
          onChange: (page) => {
            setPage(page);
          },
        }}
      />
    </Modal>
  );
};

export default HistoryDialog;
